import FormValidator from './FormValidator.vue'
import InputCheckbox from './InputCheckbox.vue'
import InputDatePicker from './InputDatePicker.vue'
import InputDropdown from './InputDropdown.vue'
import InputErrorText from './InputErrorText.vue'
import InputFile from './InputFile.vue'
import InputPhoneNumber from './InputPhoneNumber.vue'
import InputSelect from './InputSelect.vue'
import InputSwitch from './InputSwitch.vue'
import InputSwitchText from './InputSwitchText.vue'
import InputText from './InputText.vue'
import InputTextarea from './InputTextarea.vue'

export default {
    'tl-form-validator': FormValidator,
    'tl-input-checkbox': InputCheckbox,
    'tl-input-datepicker': InputDatePicker,
    'tl-input-dropdown': InputDropdown,
    'tl-input-error-text': InputErrorText,
    'tl-input-file': InputFile,
    'tl-input-phone-number': InputPhoneNumber,
    'tl-input-select': InputSelect,
    'tl-input-switch-text': InputSwitchText,
    'tl-input-switch': InputSwitch,
    'tl-input-text': InputText,
    'tl-input-textarea': InputTextarea,
}
